import * as React from "react";

import styled from "@emotion/styled";

import { Link } from "gatsby";
import Arrow from '../svgs/arrow-down.svg';

const StyledDropdown = styled.div`
  display: inline-flex;
  position: relative;

  button {
    position: relative;
    display: flex;
    align-items: center;
    text-transform: uppercase;

    &::after {
      content: "";
      position: absolute;
      display: block;
      height: 5rem;
      width: 100%;
      transform: scale(2);
    }

    img {
      height: 2.4rem;
      width: 2.4rem;
      margin-left: var(--nano);
      transition: all .2s;
    }
  }

  .drop-links {
    position: absolute;
    top: 4rem;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    min-width: 27rem;
    padding: var(--mimac);
    background: var(--white);
    font-size: var(--p-x-small);
    box-shadow: var(--shadow-normal);
    border-radius: 0.7rem;
  }

  a {
    white-space: nowrap;

    &:not(:last-child) {
      margin-bottom: var(--mimac);
    }
  }
`;

export interface DropdownProps {
  text: string;
  links: { to: string; text: string }[];
}

const Dropdown = ({ text, links }: DropdownProps) => {
  const [shown, setShown] = React.useState(false);

  return (
    <StyledDropdown onMouseLeave={() => setShown(false)}>
      <button 
        aria-label={ shown ? "Hide Dropdown's Content" : "Show Dropdown's Content"}
        aria-live="assertive"
        onMouseEnter={() => setShown(true)} onClick={() => setShown(true)}
      >
        {text}
        <img src={Arrow} alt="Arrow" style={shown ? {transform: 'rotate(180deg)'} : {}} />
      </button>
      {shown ? (
        <div className="drop-links">
          {links.map((l) => (
            <Link to={l.to} key={l.to}>
              {l.text}
            </Link>
          ))}
        </div>
      ) : null}
    </StyledDropdown>
  );
};

export default Dropdown;
